// Generated from SVG to Code Figma Plugin

export const ProductLine4 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height="16"
      width="18"
      rx="3"
      stroke="currentColor"
      strokeWidth="1.5"
      transform="rotate(-180 21 20)"
      x="21"
      y="20"
    />
  </svg>
);
